import GroupedSettings from './fragments';
import GroupedSettingsList from './fragments/List';
import GroupedSettingsListItem from './fragments/ListItem';

export default {
    Root: GroupedSettings,
    List: GroupedSettingsList,
    ListItem: GroupedSettingsListItem,
};
